/*
 * Barra de acciones del tablero, replica del .toolbar del HTML original:
 * cargar la sabana del mes, guardar el snapshot, limpiar y modo presentacion.
 */
import { useRef, useState } from "react";

import { htmlTheme } from "./utils/carthelp";

//Boton principal del header (replica del .btn del HTML)
const btnStyle = {
  background: htmlTheme.coral,
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: 8,
  fontSize: 13.5,
  fontWeight: 600,
  cursor: "pointer",
  transition: "background .15s ease",
};

//Boton secundario del header (replica del .btn.secondary del HTML)
const secondaryStyle = { ...btnStyle, background: "rgba(255,255,255,.16)" };

/**
 * Renderiza un boton de la barra con su color de hover
 * @param {Object} props Propiedades del componente
 * @param {boolean} props.secondary Usa el estilo traslucido del header
 * @param {Function} props.onClick Accion del boton
 * @param {React.ReactNode} props.children Texto del boton
 */
const ToolBtn = ({ secondary, onClick, children }) => {
  const [bHover, setHover] = useState(false);
  const sHoverBg = secondary ? "rgba(255,255,255,.28)" : htmlTheme.coralDark;
  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        ...(secondary ? secondaryStyle : btnStyle),
        ...(bHover ? { background: sHoverBg } : {}),
      }}
    >
      {children}
    </button>
  );
};

/**
 * Renderiza los botones de accion del encabezado
 * @param {Object} props Propiedades del componente
 * @param {Function} props.onLoadFile Recibe el archivo .xlsx elegido
 * @param {Function} props.onSaveSnapshot Guarda el corte del mes
 * @param {Function} props.onReset Vuelve al tablero publicado
 * @param {Function} props.onTogglePresent Entra o sale del modo presentacion
 * @param {boolean} props.isPresenting Indica si el modo presentacion esta activo
 * @param {boolean} props.canReset Hay sabana cargada o filtros que limpiar
 */
const Toolbarx = ({ onLoadFile, onSaveSnapshot, onReset, onTogglePresent, isPresenting, canReset }) => {
  const refInput = useRef(null);

  //El input se limpia siempre para poder recargar el mismo archivo dos veces
  const handleChange = (mEvent) => {
    const mFile = mEvent.target.files[0];
    mEvent.target.value = "";
    if (mFile) onLoadFile(mFile);
  };

  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
      <input
        ref={refInput}
        type="file"
        accept=".xlsx,.xls"
        aria-label="Cargar sábana"
        style={{ display: "none" }}
        onChange={handleChange}
      />
      {!isPresenting && (
        <>
          <ToolBtn onClick={() => refInput.current?.click()}>📂 Cargar sábana (.xlsx)</ToolBtn>
          <ToolBtn secondary onClick={onSaveSnapshot}>
            💾 Guardar snapshot del mes
          </ToolBtn>
          {canReset && (
            <ToolBtn secondary onClick={onReset}>
              🔄 Limpiar tablero
            </ToolBtn>
          )}
        </>
      )}
      <ToolBtn secondary onClick={onTogglePresent}>
        {isPresenting ? "🖥️ Salir de presentación" : "🖥️ Modo Presentación"}
      </ToolBtn>
    </div>
  );
};

export default Toolbarx;
